import { Text } from '@oneaudi/unified-web-components';
import type { FC } from 'react';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { SYS_SIZE_FIXED_200, SYS_SIZE_FIXED_300 } from '@oneaudi/unified-web-common';
import { Icon } from '@oneaudi/unified-web-alpha-components';
import { UniversalStateContext } from '../context/UniversalStateContext';

const Container = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: top;
  grid-template-columns: auto 1fr;
  margin-block-start: ${SYS_SIZE_FIXED_200};
  margin-block-end: ${SYS_SIZE_FIXED_300};
  gap: 6px;
  svg {
    padding-top: 2px;
  }
`;
const StyledIcon = styled(Icon)`
  color: ${process.env.IS_LEGACY ? 'black' : 'white'};
`;

export const MoreOptionsDisclaimer: FC = () => {
  const { i18nTexts } = useContext(UniversalStateContext) ?? { moreColorsAndRims: '' };

  if (!i18nTexts?.moreColorsAndRims) {
    return null;
  }
  return (
    <Container>
      <StyledIcon name="info-circle" size="xs" />
      <Text variant={{ order: process.env.IS_LEGACY ? '2' : '3', style: 'normal' }} tag="span">
        {i18nTexts.moreColorsAndRims}
      </Text>
    </Container>
  );
};
